import React, { useContext } from "react";
import {
    Grid,
    FormControl,
    FormLabel,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    MenuItem,
    CircularProgress,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { SALUTATION_LIST } from "constant";
import { SignupViewContext } from "components/Signup.page";
import { useStyles } from "../login/Login.page.style";
import login_bg_mobile from "images/login_bg_mobile.png";
import LoginIcon from "images/loginIcon.png";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import LoadingScreen from "components/common/LoadingScreen";
import LockPromptDialog from "components/common/LockPromptDialog";
import { AgreementDialog } from "components/common";

const SignupMobile = () => {
    const {
        register,
        isLoading,
        theme,
        logoLink,
        handleSubmit,
        onSubmit,
        control,
        errors,
        agreePICS,
        handleChangeAgreePICS,
        specifyVisible,
        orgList,
        goBack,
        loginRemainTime,
        openAgreement,
        onCloseAgreement,
        handleAgree,
        agreementTitle,
        agreementContent,
        canAgree,
        timeLeft,
        showLockTip,
        handleSignupSuccess,
        lockTipContent,
    } = useContext(SignupViewContext);

    const classes = useStyles();

    return (
        <div style={{ height: "100%", overflow: "hidden", position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
            <div style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
                <LoadingScreen open={isLoading} />
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <Grid container className={classes.fullHeight} flexWrap={"nowrap"}>
                            <Grid container item>
                                <span className={classes.blueRound} />
                                <span className={classes.yellowRound} />
                                <Grid container direction="column">
                                    <Grid container>
                                        <div>
                                            <img width="75%" src={login_bg_mobile} alt="bg" />
                                        </div>
                                    </Grid>
                                    <div>
                                        <a href={logoLink} target={"_blank"} rel="noreferrer">
                                            <img style={{ maxWidth: "100%" }} src={LoginIcon} alt={"icon"} className={classes.loginIcon} />
                                        </a>
                                    </div>

                                    <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
                                        <Grid container direction={"column"} className={classes.loginFormContainer}>
                                            <Grid item style={{ lineHeight: 1.1 }}>
                                                <div className={classes.welcomeFont}>Sign up</div>
                                            </Grid>

                                            <Grid item container direction={"column"} className={classes.loginInputBox}>
                                                <Grid item className={classes.loginFont}>
                                                    ACCOUNT INFORMATION
                                                </Grid>

                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="salutation" className={classes.blackColor}>
                                                            Salutation
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    select
                                                                    {...field}
                                                                    {...register("salutation")}
                                                                    error={!!errors?.salutation}
                                                                    helperText={errors?.salutation?.message}
                                                                    variant="standard"
                                                                    InputProps={{ className: classes.inputStyle }}
                                                                >
                                                                    {SALUTATION_LIST.map((item) => (
                                                                        <MenuItem key={item} value={item}>{item}</MenuItem>
                                                                    ))}
                                                                </TextField>
                                                            )}
                                                            id={"salutation"}
                                                            name="salutation"
                                                            control={control}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="email" className={classes.blackColor}>
                                                            Institution Email
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    {...register("email")}
                                                                    error={!!errors?.email}
                                                                    helperText={errors?.email?.message}
                                                                    variant="standard"
                                                                    InputProps={{ className: classes.inputStyle }}
                                                                    inputProps={{ maxLength: 60 }}
                                                                />
                                                            )}
                                                            id={"email"}
                                                            name="email"
                                                            control={control}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="lastName" className={classes.blackColor}>
                                                            Last Name
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    {...register("lastName")}
                                                                    error={!!errors?.lastName}
                                                                    helperText={errors?.lastName?.message}
                                                                    variant="standard"
                                                                    InputProps={{ className: classes.inputStyle }}
                                                                    inputProps={{ maxLength: 50 }}
                                                                />
                                                            )}
                                                            id={"lastName"}
                                                            name="lastName"
                                                            control={control}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="firstName" className={classes.blackColor}>
                                                            First Name
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    {...register("firstName")}
                                                                    error={!!errors?.firstName}
                                                                    helperText={errors?.firstName?.message}
                                                                    variant="standard"
                                                                    InputProps={{ className: classes.inputStyle }}
                                                                    inputProps={{ maxLength: 50 }}
                                                                />
                                                            )}
                                                            id={"firstName"}
                                                            name="firstName"
                                                            control={control}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="organizationId" className={classes.blackColor}>
                                                            Institution
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    select
                                                                    {...field}
                                                                    {...register("organizationId")}
                                                                    error={!!errors?.organizationId}
                                                                    helperText={errors?.organizationId?.message}
                                                                    variant="standard"
                                                                    InputProps={{ className: classes.inputStyle }}
                                                                >
                                                                    {Array.isArray(orgList) && orgList.map((item) => (
                                                                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                                                    ))}
                                                                </TextField>
                                                            )}
                                                            id={"organizationId"}
                                                            name="organizationId"
                                                            control={control}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                {specifyVisible && (
                                                    <Grid item className={classes.LoginInputWrapper}>
                                                        <FormControl fullWidth>
                                                            <FormLabel htmlFor="specify" className={classes.blackColor}>
                                                                Please specify
                                                            </FormLabel>
                                                            <Controller
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        {...register("specify")}
                                                                        error={!!errors?.specify}
                                                                        helperText={errors?.specify?.message}
                                                                        variant="standard"
                                                                        InputProps={{ className: classes.inputStyle }}
                                                                        inputProps={{ maxLength: 100 }}
                                                                    />
                                                                )}
                                                                id={"specify"}
                                                                name="specify"
                                                                control={control}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                )}

                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="affiliationType" className={classes.blackColor}>
                                                            Affiliation Type
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    select
                                                                    {...field}
                                                                    {...register("affiliationType")}
                                                                    error={!!errors?.affiliationType}
                                                                    helperText={errors?.affiliationType?.message}
                                                                    variant="standard"
                                                                    InputProps={{ className: classes.inputStyle }}
                                                                >
                                                                    <MenuItem value="Staff">Staff</MenuItem>
                                                                    <MenuItem value="Student">Student</MenuItem>
                                                                </TextField>
                                                            )}
                                                            id={"affiliationType"}
                                                            name={"affiliationType"}
                                                            control={control}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="dept" className={classes.blackColor}>
                                                            Faculty/Dept
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    {...register("dept")}
                                                                    error={!!errors?.dept}
                                                                    helperText={errors?.dept?.message}
                                                                    variant="standard"
                                                                    InputProps={{ className: classes.inputStyle }}
                                                                    inputProps={{ maxLength: 100 }}
                                                                />
                                                            )}
                                                            id={"dept"}
                                                            name={"dept"}
                                                            control={control}
                                                        />
                                                    </FormControl>
                                                </Grid>

												<Grid item className={classes.mobileInputTipWrapper}>
													<div className={classes.mobileInputTipText}>(No abbreviation)</div>
												</Grid>

                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="jobTitle" className={classes.blackColor}>
                                                            Job Title
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    {...register("jobTitle")}
                                                                    error={!!errors?.jobTitle}
                                                                    helperText={errors?.jobTitle?.message}
                                                                    variant="standard"
                                                                    InputProps={{ className: classes.inputStyle }}
                                                                    inputProps={{ maxLength: 50 }}
                                                                />
                                                            )}
                                                            id={"jobTitle"}
                                                            name={"jobTitle"}
                                                            control={control}
                                                        />
                                                    </FormControl>
                                                </Grid>

												<Grid item className={classes.mobileInputTipWrapper}>
													<div className={classes.mobileInputTipText}>
														eg. PhD Student, Researcher Assistant, Professor (no abbreviation)
													</div>
												</Grid>

                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="cardNumber" className={classes.blackColor}>
                                                            Student/Staff ID No.
                                                        </FormLabel>
                                                        <Controller
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    {...register("cardNumber")}
                                                                    error={!!errors?.cardNumber}
                                                                    helperText={errors?.cardNumber?.message}
                                                                    variant="standard"
                                                                    InputProps={{ className: classes.inputStyle }}
                                                                    inputProps={{ maxLength: 30 }}
                                                                />
                                                            )}
                                                            id={"cardNumber"}
                                                            name={"cardNumber"}
                                                            control={control}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                                <Grid item className={classes.LoginInputWrapper}>
                                                    <FormControl fullWidth>
                                                        <FormLabel htmlFor="mobileNumber" className={classes.blackColor}>
                                                            Phone Number
                                                        </FormLabel>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            <Controller
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        {...register("countryCode")}
                                                                        error={!!errors?.countryCode}
                                                                        helperText={errors?.countryCode?.message}
                                                                        variant="standard"
                                                                        InputProps={{ className: classes.inputStyle }}
                                                                        inputProps={{ maxLength: 8 }}
                                                                        sx={{ width: "28%", mr: 1 }}
                                                                    />
                                                                )}
                                                                id={"countryCode"}
                                                                name={"countryCode"}
                                                                control={control}
                                                            />

                                                            <Controller
                                                                render={({ field }) => (
                                                                    <TextField
                                                                        {...field}
                                                                        {...register("mobileNumber")}
                                                                        error={!!errors?.mobileNumber}
                                                                        helperText={errors?.mobileNumber?.message}
                                                                        variant="standard"
                                                                        InputProps={{ className: classes.inputStyle }}
                                                                        inputProps={{ maxLength: 20 }}
                                                                        sx={{ width: "70%" }}
                                                                    />
                                                                )}
                                                                id={"mobileNumber"}
                                                                name={"mobileNumber"}
                                                                control={control}
                                                            />
                                                        </div>
                                                    </FormControl>
                                                </Grid>
                                                
                                                <Grid item style={{ marginTop: 12 }}>
                                                    <FormControlLabel
                                                        control={<Checkbox checked={agreePICS} onChange={handleChangeAgreePICS} color="primary" />}
                                                        label={"I accept and agree to the Personal Information Collection Statement."}
                                                    />
                                                </Grid>

                                                <Grid item container className={classes.LoginInputWrapper} justifyContent="center">
                                                    <Grid item>
                                                        <FormControl>
                                                            <Button
                                                                type="submit"
                                                                variant="contained"
                                                                color="primary"
                                                                style={{ textTransform: "none", fontFamily: "Quicksand-SemiBold", fontSize: 16 }}
                                                                disabled={!agreePICS}
                                                            >
                                                                Sign up
                                                                {loginRemainTime > 0 ? <CircularProgress size={16} /> : null}
                                                            </Button>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item style={{ marginLeft: 12 }}>
                                                        <Button variant="contained" color="primary" onClick={goBack} style={{ textTransform: "none", fontFamily: "Quicksand-SemiBold", fontSize: 16 }}>
                                                            Cancel
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </form>

                                    <AgreementDialog
                                        open={openAgreement}
                                        onClose={onCloseAgreement}
                                        title={agreementTitle}
                                        content={agreementContent}
                                        onAgree={handleAgree}
                                        canAgree={canAgree}
                                        timeLeft={timeLeft}
                                    />

                                    <LockPromptDialog open={showLockTip} onClose={handleSignupSuccess} content={lockTipContent} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </ThemeProvider>
                </StyledEngineProvider>
            </div>
        </div>
    );
};

export default SignupMobile;
